import { useEffect, useRef, useState } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';

const DashboardIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 0H1.25C0.918479 0 0.600537 0.131696 0.366116 0.366116C0.131696 0.600537 0 0.918479 0 1.25V5C0 5.33152 0.131696 5.64946 0.366116 5.88388C0.600537 6.1183 0.918479 6.25 1.25 6.25H5C5.33152 6.25 5.64946 6.1183 5.88388 5.88388C6.1183 5.64946 6.25 5.33152 6.25 5V1.25C6.25 0.918479 6.1183 0.600537 5.88388 0.366116C5.64946 0.131696 5.33152 0 5 0ZM5 5H1.25V1.25H5V5ZM12.5 0H8.75C8.41848 0 8.10054 0.131696 7.86612 0.366116C7.6317 0.600537 7.5 0.918479 7.5 1.25V5C7.5 5.33152 7.6317 5.64946 7.86612 5.88388C8.10054 6.1183 8.41848 6.25 8.75 6.25H12.5C12.8315 6.25 13.1495 6.1183 13.3839 5.88388C13.6183 5.64946 13.75 5.33152 13.75 5V1.25C13.75 0.918479 13.6183 0.600537 13.3839 0.366116C13.1495 0.131696 12.8315 0 12.5 0ZM12.5 5H8.75V1.25H12.5V5ZM5 7.5H1.25C0.918479 7.5 0.600537 7.6317 0.366116 7.86612C0.131696 8.10054 0 8.41848 0 8.75V12.5C0 12.8315 0.131696 13.1495 0.366116 13.3839C0.600537 13.6183 0.918479 13.75 1.25 13.75H5C5.33152 13.75 5.64946 13.6183 5.88388 13.3839C6.1183 13.1495 6.25 12.8315 6.25 12.5V8.75C6.25 8.41848 6.1183 8.10054 5.88388 7.86612C5.64946 7.6317 5.33152 7.5 5 7.5ZM5 12.5H1.25V8.75H5V12.5ZM12.5 7.5H8.75C8.41848 7.5 8.10054 7.6317 7.86612 7.86612C7.6317 8.10054 7.5 8.41848 7.5 8.75V12.5C7.5 12.8315 7.6317 13.1495 7.86612 13.3839C8.10054 13.6183 8.41848 13.75 8.75 13.75H12.5C12.8315 13.75 13.1495 13.6183 13.3839 13.3839C13.6183 13.1495 13.75 12.8315 13.75 12.5V8.75C13.75 8.41848 13.6183 8.10054 13.3839 7.86612C13.1495 7.6317 12.8315 7.5 12.5 7.5ZM12.5 12.5H8.75V8.75H12.5V12.5Z"
      fill="currentColor"
    />
  </svg>
);

const ExploreIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM10 16.875C8.64026 16.875 7.31105 16.4718 6.18046 15.7164C5.04987 14.9609 4.16868 13.8872 3.64833 12.6309C3.12798 11.3747 2.99183 9.99237 3.2571 8.65875C3.52238 7.32513 4.17716 6.10013 5.13864 5.13864C6.10013 4.17716 7.32514 3.52237 8.65876 3.2571C9.99238 2.99183 11.3747 3.12798 12.631 3.64833C13.8872 4.16868 14.9609 5.04987 15.7164 6.18045C16.4718 7.31104 16.875 8.64025 16.875 10C16.8729 11.8227 16.1479 13.5702 14.8591 14.8591C13.5702 16.1479 11.8227 16.8729 10 16.875ZM13.4703 5.69062L8.47032 8.19062C8.34943 8.25135 8.25135 8.34943 8.19063 8.47031L5.69063 13.4703C5.64293 13.5656 5.6204 13.6716 5.62519 13.7781C5.62997 13.8845 5.66191 13.988 5.71796 14.0787C5.77402 14.1693 5.85233 14.2442 5.94545 14.296C6.03857 14.3479 6.14341 14.3751 6.25 14.375C6.34703 14.3749 6.44273 14.3524 6.52969 14.3094L11.5297 11.8094C11.6506 11.7487 11.7487 11.6506 11.8094 11.5297L14.3094 6.52969C14.3684 6.41229 14.3888 6.27929 14.3679 6.14958C14.347 6.01988 14.2857 5.90006 14.1928 5.80716C14.0999 5.71426 13.9801 5.653 13.8504 5.63208C13.7207 5.61116 13.5877 5.63164 13.4703 5.69062ZM10.7813 10.7812L7.64766 12.3523L9.21875 9.21875L12.3555 7.65078L10.7813 10.7812Z"
      fill="currentColor"
    />
  </svg>
);

const LearningIcon = ({ className = 'w-4 h-4' }) => (
  <svg className={className} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.0977 15.199L15.5047 2.87092C15.4712 2.7097 15.4061 2.5567 15.3132 2.4207C15.2204 2.2847 15.1016 2.16839 14.9637 2.07844C14.8257 1.9885 14.6714 1.92669 14.5095 1.89657C14.3476 1.86646 14.1814 1.86862 14.0203 1.90295L10.3633 2.68889C10.0398 2.75971 9.75738 2.9554 9.57742 3.23337C9.39747 3.51135 9.33455 3.84914 9.40234 4.17326L11.9953 16.5014C12.0531 16.7827 12.206 17.0354 12.4282 17.2173C12.6504 17.3991 12.9285 17.4989 13.2156 17.4998C13.3044 17.4997 13.3929 17.4903 13.4797 17.4717L17.1367 16.6858C17.4606 16.6148 17.7433 16.4187 17.9233 16.1402C18.1033 15.8618 18.1659 15.5235 18.0977 15.199ZM10.625 3.91779C10.625 3.91311 10.625 3.91076 10.625 3.91076L14.2812 3.12951L14.5414 4.36936L10.8852 5.15607L10.625 3.91779ZM11.1422 6.37639L14.8 5.59123L15.0609 6.83342L11.4062 7.61935L11.1422 6.37639ZM11.6609 8.84279L15.3188 8.05685L16.3578 12.9975L12.7 13.7834L11.6609 8.84279ZM16.875 15.4639L13.2188 16.2451L12.9586 15.0053L16.6148 14.2186L16.875 15.4569C16.875 15.4615 16.875 15.4639 16.875 15.4639ZM8.125 2.49982H4.375C4.04348 2.49982 3.72554 2.63152 3.49112 2.86594C3.2567 3.10036 3.125 3.4183 3.125 3.74982V16.2498C3.125 16.5813 3.2567 16.8993 3.49112 17.1337C3.72554 17.3681 4.04348 17.4998 4.375 17.4998H8.125C8.45652 17.4998 8.77446 17.3681 9.00888 17.1337C9.2433 16.8993 9.375 16.5813 9.375 16.2498V3.74982C9.375 3.4183 9.2433 3.10036 9.00888 2.86594C8.77446 2.63152 8.45652 2.49982 8.125 2.49982ZM4.375 3.74982H8.125V4.99982H4.375V3.74982ZM4.375 6.24982H8.125V13.7498H4.375V6.24982ZM8.125 16.2498H4.375V14.9998H8.125V16.2498Z"
      fill="currentColor"
    />
  </svg>
);

/** Same shape as `public/images/Cert.svg` — uses currentColor so inactive = black, active = blue */
const CertIcon = ({ className = 'w-4 h-4 shrink-0' }) => (
  <svg className={className} viewBox="0 0 70 61" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
    <path
      d="M32.5 30C32.5 30.663 32.2366 31.2989 31.7678 31.7678C31.2989 32.2366 30.663 32.5 30 32.5H15C14.337 32.5 13.7011 32.2366 13.2322 31.7678C12.7634 31.2989 12.5 30.663 12.5 30C12.5 29.337 12.7634 28.7011 13.2322 28.2322C13.7011 27.7634 14.337 27.5 15 27.5H30C30.663 27.5 31.2989 27.7634 31.7678 28.2322C32.2366 28.7011 32.5 29.337 32.5 30ZM30 17.5H15C14.337 17.5 13.7011 17.7634 13.2322 18.2322C12.7634 18.7011 12.5 19.337 12.5 20C12.5 20.663 12.7634 21.2989 13.2322 21.7678C13.7011 22.2366 14.337 22.5 15 22.5H30C30.663 22.5 31.2989 22.2366 31.7678 21.7678C32.2366 21.2989 32.5 20.663 32.5 20C32.5 19.337 32.2366 18.7011 31.7678 18.2322C31.2989 17.7634 30.663 17.5 30 17.5ZM65 37.9594V57.5C65.004 57.9407 64.8913 58.3747 64.6735 58.7579C64.4557 59.1411 64.1405 59.4599 63.7598 59.6819C63.3791 59.904 62.9464 60.0215 62.5056 60.0225C62.0649 60.0235 61.6317 59.9079 61.25 59.6875L53.75 55.3937L46.25 59.6875C45.8683 59.9079 45.4351 60.0235 44.9944 60.0225C44.5536 60.0215 44.1209 59.904 43.7402 59.6819C43.3595 59.4599 43.0443 59.1411 42.8265 58.7579C42.6087 58.3747 42.496 57.9407 42.5 57.5V50H5C3.67392 50 2.40215 49.4732 1.46447 48.5355C0.526784 47.5979 0 46.3261 0 45V5C0 3.67392 0.526784 2.40215 1.46447 1.46447C2.40215 0.526784 3.67392 0 5 0H60C61.3261 0 62.5979 0.526784 63.5355 1.46447C64.4732 2.40215 65 3.67392 65 5V14.5406C66.5804 16.054 67.838 17.8716 68.6972 19.884C69.5564 21.8964 69.9993 24.0619 69.9993 26.25C69.9993 28.4381 69.5564 30.6036 68.6972 32.616C67.838 34.6284 66.5804 36.446 65 37.9594ZM42.5 45V37.9594C39.7757 35.332 38.0539 31.836 37.6318 28.0747C37.2098 24.3135 38.1139 20.5228 40.1882 17.357C42.2625 14.1911 45.3768 11.8486 48.9937 10.7337C52.6106 9.61878 56.5033 9.80138 60 11.25V5H5V45H42.5ZM60 41.25C58.0201 42.0772 55.8957 42.5031 53.75 42.5031C51.6043 42.5031 49.4799 42.0772 47.5 41.25V53.1938L52.5 50.3312C52.8778 50.1153 53.3054 50.0017 53.7406 50.0017C54.1758 50.0017 54.6034 50.1153 54.9813 50.3312L59.9813 53.1938L60 41.25ZM65 26.25C65 24.025 64.3402 21.8499 63.104 19.9998C61.8679 18.1498 60.1109 16.7078 58.0552 15.8564C55.9995 15.0049 53.7375 14.7821 51.5552 15.2162C49.3729 15.6502 47.3684 16.7217 45.795 18.295C44.2217 19.8684 43.1502 21.8729 42.7162 24.0552C42.2821 26.2375 42.5049 28.4995 43.3564 30.5552C44.2078 32.6109 45.6498 34.3679 47.4998 35.604C49.3499 36.8402 51.525 37.5 53.75 37.5C55.2274 37.5 56.6903 37.209 58.0552 36.6436C59.4201 36.0783 60.6603 35.2496 61.705 34.205C62.7496 33.1603 63.5783 31.9201 64.1436 30.5552C64.709 29.1903 65 27.7274 65 26.25Z"
      fill="currentColor"
    />
  </svg>
);

const navItems = [
  {
    label: 'Dashboard',
    icon: (
      <DashboardIcon />
    ),
    to: '/dashboard',
    end: true,
  },
  {
    label: 'Explore',
    icon: (
      <ExploreIcon />
    ),
    to: '/dashboard/explore',
  },
  {
    label: 'My Learnings',
    icon: (
      <LearningIcon />
    ),
    to: '/dashboard/learnings',
  },
  {
    label: 'My Certificates',
    icon: <CertIcon />,
    to: '/dashboard/certificates',
  },
];

const bottomItems = [
  {
    label: 'Notifications',
    to: '/dashboard/notifications',
    icon: (
      <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18 8a6 6 0 10-12 0c0 7-3 7-3 7h18s-3 0-3-7"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.73 21a2 2 0 01-3.46 0"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    label: 'Settings',
    to: '/dashboard/settings',
    icon: (
      <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 15.5a3.5 3.5 0 110-7 3.5 3.5 0 010 7z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.4 15a1.8 1.8 0 00.36 1.98l.05.05a2.2 2.2 0 01-1.55 3.75 2.2 2.2 0 01-1.56-.64l-.05-.05A1.8 1.8 0 0015 19.4a1.8 1.8 0 00-1 .33 1.8 1.8 0 00-.7 1.47V21a2.2 2.2 0 01-4.4 0v-.07a1.8 1.8 0 00-.7-1.46 1.8 1.8 0 00-1-.33 1.8 1.8 0 00-1.98.36l-.05.05A2.2 2.2 0 012.5 18a2.2 2.2 0 01.64-1.56l.05-.05A1.8 1.8 0 004.6 15a1.8 1.8 0 00-.33-1 1.8 1.8 0 00-1.47-.7H2.7a2.2 2.2 0 010-4.4h.07a1.8 1.8 0 001.46-.7 1.8 1.8 0 00.33-1 1.8 1.8 0 00-.36-1.98l-.05-.05A2.2 2.2 0 015 2.5a2.2 2.2 0 011.56.64l.05.05A1.8 1.8 0 009 4.6a1.8 1.8 0 001-.33 1.8 1.8 0 00.7-1.47V2.7a2.2 2.2 0 014.4 0v.07a1.8 1.8 0 00.7 1.46 1.8 1.8 0 001 .33 1.8 1.8 0 001.98-.36l.05-.05A2.2 2.2 0 0121.5 6a2.2 2.2 0 01-.64 1.56l-.05.05A1.8 1.8 0 0019.4 9c0 .35.11.69.33 1 .22.31.53.55.9.7.24.1.5.15.76.15H21.3a2.2 2.2 0 010 4.4h-.07a1.8 1.8 0 00-1.46.7 1.8 1.8 0 00-.33 1z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const [authUser, setAuthUser] = useState(null);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const profileMenuRef = useRef(null);

  useEffect(() => {
    function syncAuthUser() {
      try {
        const storedUser = localStorage.getItem('authUser');
        setAuthUser(storedUser ? JSON.parse(storedUser) : null);
      } catch (error) {
        setAuthUser(null);
      }
    }

    syncAuthUser();
    window.addEventListener('storage', syncAuthUser);

    return () => {
      window.removeEventListener('storage', syncAuthUser);
    };
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    function handlePointerDown(event) {
      if (!profileMenuRef.current?.contains(event.target)) {
        setIsProfileMenuOpen(false);
      }
    }

    function handleEscape(event) {
      if (event.key === 'Escape') {
        setIsProfileMenuOpen(false);
      }
    }

    document.addEventListener('mousedown', handlePointerDown);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousedown', handlePointerDown);
      document.removeEventListener('keydown', handleEscape);
    };
  }, []);

  function extractUsernameFromEmail(email) {
    if (!email || typeof email !== 'string') return null;
    const [username] = email.split('@');
    return username || null;
  }

  const displayName = authUser
    ? authUser.name ||
      authUser.fullName ||
      authUser.firstName ||
      extractUsernameFromEmail(authUser.email) ||
      'Profile'
    : 'Profile';

  function handleLogout() {
    localStorage.removeItem('authToken');
    localStorage.removeItem('authUser');
    setAuthUser(null);
    setIsProfileMenuOpen(false);
    navigate('/');
  }

  return (
    <>
      <div className="lg:hidden border-b border-[#E5E7EB] bg-white px-3 py-3">
        <div className="flex items-center justify-between gap-3">
          <img
            src={`${process.env.PUBLIC_URL}/images/llogo.png`}
            alt="AI Sanctuary"
            className="h-10 w-auto"
          />
          <button
            type="button"
            onClick={() => setIsMobileMenuOpen((open) => !open)}
            className="inline-flex items-center gap-2 rounded-lg border border-[#E5E7EB] px-3 py-2 text-xs font-semibold text-[#111827]"
            aria-expanded={isMobileMenuOpen}
            aria-label="Toggle dashboard menu"
          >
            <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
              <path d="M4 7h16M4 12h16M4 17h16" strokeLinecap="round" />
            </svg>
            Menu
          </button>
        </div>
        {isMobileMenuOpen ? (
          <div className="mt-3 rounded-xl border border-[#E5E7EB] bg-white p-2 shadow-sm">
            <nav className="space-y-1">
              {[...navItems, ...bottomItems].map((item) => (
                <NavLink
                  key={`mobile-${item.label}`}
                  to={item.to}
                  end={item.end}
                  className={({ isActive }) =>
                    [
                      'block rounded-lg px-3 py-2 text-sm',
                      isActive ? 'bg-[#E9F1FF] text-[#2563EB] font-medium' : 'text-[#111827] hover:bg-[#F3F4F6]',
                    ].join(' ')
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
            <button
              type="button"
              onClick={handleLogout}
              className="mt-2 w-full rounded-lg border border-[#FECACA] bg-[#FEF2F2] px-3 py-2 text-left text-sm font-semibold text-[#B91C1C]"
            >
              Log out
            </button>
          </div>
        ) : null}
      </div>

      <aside className="sticky top-0 hidden h-screen w-64 border-r border-[#E5E7EB] bg-white px-4 pb-6 pt-6 lg:flex lg:flex-col">
        <div className="flex-1">
        {/* Logo (above navigation) */}
        <div className="mb-6 flex items-center justify-start px-1">
          <img
            src={`${process.env.PUBLIC_URL}/images/llogo.png`}
            alt="AI Sanctuary"
            className="h-16 w-auto max-w-[320px]"
          />
        </div>

        {/* Navigation */}
        <nav className="space-y-1 text-sm">
          {navItems.map((item) => (
            <NavLink
              key={item.label}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                [
                  'flex items-center gap-2.5 px-3 py-2.5 rounded-xl cursor-pointer transition-colors',
                  isActive
                    ? 'bg-[#E9F1FF] text-[#2563EB] font-medium'
                    : 'text-[#111827] hover:bg-gray-100',
                ].join(' ')
              }
            >
              <span className="shrink-0">{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </div>

      {/* Bottom section */}
      <div className="pt-6">
        <div className="h-px bg-[#E5E7EB] mb-4" />
        <nav className="space-y-1 text-sm">
          {bottomItems.map((item) => (
            <NavLink
              key={item.label}
              to={item.to}
              className={({ isActive }) =>
                [
                  'flex items-center gap-2.5 px-3 py-2.5 rounded-xl cursor-pointer transition-colors',
                  isActive
                    ? 'bg-[#E9F1FF] text-[#2563EB] font-medium'
                    : 'text-[#111827] hover:bg-gray-100',
                ].join(' ')
              }
            >
              <span className="shrink-0">{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="mt-4 relative" ref={profileMenuRef}>
          <button
            type="button"
            onClick={() => setIsProfileMenuOpen((open) => !open)}
            className="flex w-full items-center gap-3 rounded-xl border border-[#E5ECF8] px-3 py-2.5 text-left transition-colors hover:bg-[#F8FAFF]"
            aria-haspopup="menu"
            aria-expanded={isProfileMenuOpen}
          >
            <div className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-[#CBD5F5] text-sm font-semibold text-[#1E3A8A]">
              {displayName.charAt(0).toUpperCase()}
            </div>
            <div className="min-w-0 flex-1">
              <div
                className="truncate text-sm font-semibold text-[#111827]"
                style={{ fontFamily: 'Manrope, sans-serif' }}
                title={authUser?.email || displayName}
              >
                {displayName}
              </div>
              <div
                className="text-xs text-[#6B7280]"
                style={{ fontFamily: 'Manrope, sans-serif' }}
              >
                Profile
              </div>
            </div>
            <svg
              className={`h-4 w-4 shrink-0 text-[#6B7280] transition-transform ${isProfileMenuOpen ? 'rotate-180' : ''}`}
              viewBox="0 0 20 20"
              fill="none"
              aria-hidden
            >
              <path d="M5 7.5 10 12.5 15 7.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>

          {isProfileMenuOpen ? (
            <div
              className="absolute bottom-[calc(100%+10px)] left-0 right-0 overflow-hidden rounded-2xl border border-[#E5ECF8] bg-white py-2 shadow-[0_18px_42px_rgba(15,23,42,0.14)]"
              role="menu"
            >
              <NavLink
                to="/dashboard"
                end
                className="block px-4 py-2.5 text-[14px] font-medium text-[#162D66] no-underline transition-colors hover:bg-[#F4F8FF]"
                style={{ letterSpacing: '0.005em' }}
                role="menuitem"
                onClick={() => setIsProfileMenuOpen(false)}
              >
                Dashboard
              </NavLink>
              <button
                type="button"
                className="block w-full bg-transparent px-4 py-2.5 text-left text-[14px] font-medium text-[#B42318] transition-colors hover:bg-[#FFF5F4]"
                style={{ letterSpacing: '0.005em' }}
                role="menuitem"
                onClick={handleLogout}
              >
                Log out
              </button>
            </div>
          ) : null}
        </div>
        </div>
      </aside>
    </>
  );
}
